import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles
} from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';
import { SupportContacts } from './SupportContacts';

interface Props {
  open: boolean;
  handleClose(): void;
}

type Strings = {
  title: string;
  contactsInfo: string;
  description: string;
  close: string;
};

export const GenericErrorModal: React.FC<Props> = ({ open, handleClose }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const strings: Strings = {
    title: t('subscriber:genericErrorModal.title', 'System Error'),
    description: t(
      'subscriber:genericErrorModal.description',
      'We were unable to complete this operation because of the payment system error. ' +
        'Please try this operation later.'
    ),
    contactsInfo: t(
      'subscriber:genericErrorModal.contactsInfo',
      'You can also contact our Customer Support for any details and assistance in establishing connection request.'
    ),
    close: t('subscriber:genericErrorModal.close', 'Close')
  };

  return (
    <Dialog open={open} maxWidth="xs" onClose={handleClose}>
      <DialogTitle>
        <span className={classes.titleWrapper}>
          <WarningIcon className={classes.warningIcon} color="error" />
          {strings.title}
        </span>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>{strings.description}</DialogContentText>
        <DialogContentText>{strings.contactsInfo}</DialogContentText>
        <SupportContacts />
        <DialogActions>
          <Button color="primary" onClick={handleClose}>
            {strings.close}
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

const useStyles = makeStyles(() =>
  createStyles({
    titleWrapper: {
      display: 'flex',
      alignItems: 'center'
    },
    errorMessage: {
      backgroundColor: 'var(--light-gray-surface)',
      borderRadius: '4px',
      border: '1px solid var(--on-surface-outline-000000-12-)',
      display: 'flex',
      alignItems: 'center',
      padding: '10px 5px',
      marginBottom: '16px'
    },
    warningIcon: {
      marginRight: '10px'
    }
  })
);
